import { GoCalendar, GoShieldLock } from "react-icons/go";
import { MdPeopleOutline, MdOutlineLink } from "react-icons/md";
import { SiCivicrm } from "react-icons/si";
import { BsBuildings } from "react-icons/bs";
import { CiBoxList } from "react-icons/ci";
import { HiOutlineCog8Tooth } from "react-icons/hi2";
import { LuCreditCard, LuFileText, LuBuilding2 } from "react-icons/lu";

const sidebar = [
  {
    titleKey: "nav.home",
    title: "Home",
    icon: <SiCivicrm />,
    link: '/settings/home' 
  },
  {
    titleKey: "sidebar.company",
    title: "Company",
    icon: <BsBuildings />,
    link: '/settings/company',
    permission: 'settings.company.view'
  },
  {
    titleKey: "sidebar.branches",
    title: "Branches",
    icon: <LuBuilding2 />,
    link: '/settings/branches',
    permission: 'settings.branches.view'
  },
  {
    titleKey: "sidebar.users",
    title: "Users",
    icon: <MdPeopleOutline />,
    link: '/settings/users',
    permission: 'settings.users.view'
  },
  {
    titleKey: "sidebar.rolesPermissions",
    title: "Roles & Permissions",
    icon: <CiBoxList />,
    link: '/settings/roles',
    permission: 'settings.roles.view'
  },
  {
    titleKey: "sidebar.preferences",
    title: "Preferences",
    icon: <HiOutlineCog8Tooth />,
    link: '/settings/preferences',
    permission: 'settings.preferences.view'
  },
  {
    titleKey: "sidebar.integrations",
    title: "Integrations",
    icon: <MdOutlineLink />,
    link: '/settings/integrations'
  },
  {
    titleKey: "settings.security",
    title: "Security",
    icon: <GoShieldLock />,
    link: '/settings/security',
    permission: 'settings.security.view'
  },
  {
    titleKey: "sidebar.billingSub",
    title: "Billing & Subscription",
    icon: <LuCreditCard />,
    link: '/settings/billing',
    permission: 'settings.billing.view'
  },
  {
    titleKey: "sidebar.auditLogs",
    title: "Audit Logs",
    icon: <LuFileText />,
    link: '/settings/audit-logs',
    permission: 'settings.security.view'
  }
];

export default sidebar;
